
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EditableTable extends Vue {
  @Prop({ required: true }) editableData!: any;
  @Prop({ required: true }) editModes!: boolean[];
  @Prop({ required: true }) monthHeaders!: string[];
  @Prop({ required: true }) tableRows!: any[];
  @Prop({ required: true }) currentYear!: number;
  @Prop({ required: true }) previousYear!: number;
  @Prop({ required: true }) loading!: boolean;
  @Prop({ required: true }) hasAdmin!: boolean;

  get mainHeaders() {
    return [
      ...this.monthHeaders,
      `Total ${this.currentYear}`,
      `Total ${this.previousYear}`,
      'Avance (%)'
    ];
  }

  get subHeadersFlat() {
    const headers = [];
    for (let i = 0; i < this.mainHeaders.length; i++) {
      if (i < this.monthHeaders.length + 1) {
        headers.push('Real', 'Objetivo');
      } else {
        headers.push('Real');
      }
    }
    return headers;
  }

  onRealClick(row: any, groupIndex: number) {
    this.$emit('click-real-cell', {
      row,
      colIndex: groupIndex,
      isTotalRow: row.key === 'globalTotal'
    });
  }

  onManualEdit(rowKey: string, colIndex: number, newValue: number) {
    this.$emit('track-change', { rowKey, colIndex, newValue });
  }

  safeGetReal(rowKey: string, colIndex: number): number {
    if (
      this.editableData[rowKey] &&
      this.editableData[rowKey][colIndex] &&
      typeof this.editableData[rowKey][colIndex].real === 'number'
    ) {
      return this.editableData[rowKey][colIndex].real;
    }
    return 0;
  }

  computeAvance(row: any): string {
    const dispatchesAccumulated = this.safeGetReal(row.key, this.monthHeaders.length);

    let budgetAccumulated = 0;
    for (let i = 0; i < this.monthHeaders.length; i++) {
      budgetAccumulated += this.editableData[row.key][i].objetivo;
    }

    if (budgetAccumulated === 0) {
      return '0%';
    }

    const avance = (dispatchesAccumulated / budgetAccumulated) * 100;
    const formatted = avance.toFixed(2);
    return formatted.endsWith('.00') ? parseInt(formatted, 10).toString() + '%' : formatted + '%';
  }

}
